import React, { useState } from 'react'
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close"
import { Dialog, Button, CircularProgress } from '@mui/material'
import { LabelInput } from '../../../components/LabelInput'
import { formatPhone, isPhone, isEmail, formatCPF, formatDate, formatDateToISOZulu, isValidDate, isDateOlderThanToday, isValidCPF } from '../../../utils/utils'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { v4 as uuidv4 } from 'uuid'
import { Radio } from '@mui/material';
import { RadioGroup } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import axios from 'axios'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import * as S from "../../Report/styles";

function EnvelopeCreationDialog(props) {
    const { open, setOpen, handleToast } = props

    const [loading, setLoading] = useState(false)

    const [openDemoRequestModal, setOpenDemoRequestModal] = useState(false)

    const closeDemoRequestModal = () => {
        setOpenDemoRequestModal(false);
    };
    
    const primaryColor = "#0b1f82"

    const minorboxStyles = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        boxShadow: 24,
        height: 300,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      };

    const [errors, setErrors] = useState({
        subject: "",
        expiration_date: "",
        name: "",
        birthdate: "",
        document_number: "",
        email: "",
        phone: "",
        document_submission_method: "",
        authentication_submission_method: ""

    })

    const [touched, setTouched] = useState({
        subject: false,
        expiration_date: false,
        name: false,
        birthdate: false,
        document_number: false,
        email: false,
        phone: false,
        document_submission_method: false,
        authentication_submission_method: false,
    })

    const errorMessages = {
        phone: "Telefone inválido",
        email: "Email inválido",
        subject: "Assunto é obrigatório",
        expiration_date: "Data de expiração inválida",
        name: "Nome é obrigatório",
        birthdate: "Data de nascimento inválida",
        document_number: "CPF inválido",
        document_submission_method: "Método de envio dos documentos é obrigatório",
        authentication_submission_method: "Método de envio do código de autenticação é obrigatório"
    }

    const [signers, setSigners] = useState([
        {
            name: "",
            birthdate: "",
            document_number: "",
            email: "",
            phone: "",
            document_submission_method: "",
            authentication_submission_method: ""
        }
    ])

    const [authenticationSubmissionErrors, setAuthenticationSubmissionErrors] = useState(Array(signers.length).fill(false));
    const [documentSubmissionErrors, setDocumentSubmissionErrors] = useState(Array(signers.length).fill(false));

    const handleBlur = (id, value) => {
        const error = !validateInput[id](value)
        setErrors({
            ...errors,
            [id]: error
        })
        setValues({
            ...values,
            [id]: value
        })
        setTouched((prevTouched) => ({
            ...prevTouched,
            [id]: true,
        }))
    }

    const handleSignerBlur = (index, id, value) => {
        setSigners([
            ...signers.slice(0, index),
            {
                ...signers[index],
                [id]: value
            },
            ...signers.slice(index + 1)
        ])
        setTouched((prevTouched) => ({
            ...prevTouched,
            [id]: true,
        }))
    }

    const [values, setValues] = useState({
        subject: "",
        expiration_date: "",
        signers: signers
    })

    const [attachedDocuments, setAttachedDocuments] = useState([])

    const resetForm = () => {
        setValues({
            subject: "",
            expiration_date: "",
            signers: [
                {
                    name: "",
                    birthdate: "",
                    document_number: "",
                    email: "",
                    phone: "",
                    document_submission_method: "",
                    authentication_submission_method: ""
                }
            ]
        })
        setSigners([
            {
                name: "",
                birthdate: "",
                document_number: "",
                email: "",
                phone: "",
                document_submission_method: "",
                authentication_submission_method: ""
            }
        ])
        setErrors({
            subject: "",
            expiration_date: "",
            name: "",
            birthdate: "",
            document_number: "",
            email: "",
            phone: "",
            document_submission_method: "",
            authentication_submission_method: ""
        })
        setAttachedDocuments([])
    }

    const validateForm = () => {
        const allValues = {
            ...values,
            signers: signers
        }

        const newDocumentSubmissionErrors = [...documentSubmissionErrors];
        const newAuthenticationSubmissionErrors = [...authenticationSubmissionErrors];

        signers.forEach((signer, index) => {
            if (!signer.document_submission_method){
                newDocumentSubmissionErrors[index] = true 
            }

            if (!signer.authentication_submission_method){
                newAuthenticationSubmissionErrors[index] = true 
            }
        })

        setDocumentSubmissionErrors(newDocumentSubmissionErrors)
        setAuthenticationSubmissionErrors(newAuthenticationSubmissionErrors)

        const allTouched = {
            ...touched,
            subject: true,
            name: true,
            birthdate: true,
            document_number: true,
            email: true,
            phone: true,
            document_submission_method: true,
            authentication_submission_method: true
        }

        setTouched(allTouched)

        const areSignersValid = Object.keys(allValues).every((key) => {
            if (key === "signers") {
                return values[key].every((signer) => {
                    return Object.keys(signer).every((signerKey) => {
                        return validateInput[signerKey](signer[signerKey])
                    })
                })
            }
            return validateInput[key](values[key])
        })

        const areAttachedDocumentsValid = attachedDocuments.every((document) => {
            return document.name !== "" && document.content !== ""
        }) && attachedDocuments.length > 0

        if (areSignersValid && attachedDocuments.length === 0) {
            alert("É necessário anexar ao menos um documento.")
        }

        return areSignersValid && areAttachedDocumentsValid
    }
    
    const validateInput = {
        phone: (value) => {
            return value === "" || isPhone(value);
        },
        email: (value) => isEmail(value),
        subject: (value) => value !== "",
        expiration_date: (value) => {
            return value === "" || isValidDate(value);
        },
        name: (value) => value !== "",
        birthdate: (value) => {
            return value === "" || isValidDate(value);
        },
        document_number: (value) => value !== "",
        document_submission_method: (value) => value !== "",
        authentication_submission_method: (value) => value !== ""
    }

    const handleInputChange = (index, field, value) => {
        const updatedSigners = [...signers]
        updatedSigners[index][field] = value
        setSigners(updatedSigners)
        const updatedValues = { ...values }
        updatedValues.signers = updatedSigners
        setValues(updatedValues)
    }

    const handleEnvelopeInputChange = (field, value) => {
        const updatedValues = { ...values }
        updatedValues[field] = value
        setValues(updatedValues)
    }

    const handleAddSigner = () => {
        const newSigner = {
            name: "",
            birthdate: "",
            document_number: "",
            email: "",
            phone: "",
            document_submission_method: "",
            authentication_submission_method: ""
        }
        const updatedSigners = [...signers, newSigner]
        setSigners(updatedSigners)
    }

    const handleRemoveSigner = (index) => {
        const updatedSigners = [...signers]
        updatedSigners.splice(index, 1)
        setSigners(updatedSigners)
    }

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result)
            }
        })
    }

    const handleAttachDocument = async (event) => {
        const files = event.target.files
        const updatedAttachedDocuments = [...attachedDocuments]
        for (let i = 0; i < files.length; i++) {
            const file = files[i]
            if (file.type !== 'application/pdf') {
                alert('O documento deve ser em formato PDF')
                return
            }
            if (file.size > 10000000) {
                alert('O documento deve ter no máximo 10MB')
                return
            }

            const document_b64 = await convertFileToBase64(file)
            const formmatedDocument = document_b64.replace('data:application/pdf;base64,', '')
            const attachedDocument = {
                id: uuidv4(),
                name: file.name,
                document_b64: formmatedDocument,
                document_type: 'pdf'
            }
            updatedAttachedDocuments.push(attachedDocument)
        }
        setAttachedDocuments(updatedAttachedDocuments)
    }

    const handleRemoveDocument = (documentId) => {
        const updatedAttachedDocuments = attachedDocuments.filter(
            (document) => document.id !== documentId
        )
        setAttachedDocuments(updatedAttachedDocuments)

        const fileInput = document.getElementById('attach-document');
        if (fileInput) {
            fileInput.value = null;
        }
    }

    const handleSubmit = async () => {
        const valid = validateForm()
        if (!valid) {
            return
        }

        setLoading(true)

        const formattedSigners = signers.map((signer) => {
            const formattedSigner = {
                id :  uuidv4(),
                name: signer.name,
                document_number: signer.document_number,
                email: (signer.email).trim(),
                document_submission_method: signer.document_submission_method,
                authentication_submission_method: signer.authentication_submission_method
            }

            if (signer.phone !== "") {
                const digitPhone = signer.phone.replace(/\D/g, '')
                formattedSigner.phone = {
                    international_dial_code: '55',
                    area_code: digitPhone.substring(0, 2),
                    number: digitPhone.substring(2, 11)
                }
            }

            if (signer.birthdate !== ""){
                formattedSigner.birthdate = formatDateToISOZulu(signer.birthdate, 'birthdate')
            }
            
            return formattedSigner
        })

        const submissionData = {
            id: uuidv4(),
            subject: values.subject,
            signers: formattedSigners
        }

        if (values.expiration_date !== ""){
            submissionData.expiration_date = formatDateToISOZulu(values.expiration_date, 'expiration_date')
        }

        try {
            const response = await axios.post("/dash/sign/envelope", submissionData)
            await handleAttacheDocumentsSubmission(response.data.envelope_key)
            await submitEnvelope(response.data.envelope_key)
            handleToast("success", "Envelope criado com sucesso!")
            resetForm()
            setOpen(false)
            window.location.reload()
        } catch (error) {
            if ([403].includes((error.response || {}).status)) {
                setOpenDemoRequestModal(true);
            } else {
                console.error(error)
                handleToast("error", "Ocorreu um erro ao criar o envelope. Tente novamente.")
            }
           
        }
        setLoading(false)
    }

    const handleAttacheDocumentsSubmission = async (envelopeKey) => {

        try {
            await Promise.all(
                attachedDocuments.map(async (signatureDocument) => {
                    const submissionData = {
                        id: uuidv4(),
                        name: signatureDocument.name,
                        document_b64: signatureDocument.document_b64,
                        document_type: signatureDocument.document_type,
                    }
                    await axios.post(`/dash/sign/envelope/${envelopeKey}/document`, submissionData)
                })
            )
        } catch (error) {
            console.error(error)
        }
    }

    const submitEnvelope = async (envelopeKey) => {
        const submissionData = {
            "status": "submitted"
        }

        try {
            await axios.patch(`/dash/sign/envelope/${envelopeKey}`, submissionData)
        } catch (error) {
            console.error(error)
        }
    }

    if (loading) {
        return (
            <Dialog open={open} onClose={() => setOpen(false)} >
                <div style={{ width: '400px', padding: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                    <CircularProgress />
                </div>
            </Dialog>
        )
    }

    return (
        <>
            <Dialog open={open}>
                <div style={{ width: '400px', padding: '2rem' }}>
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            setOpen(false)
                            resetForm()
                        }}
                        style={{ float: "right" }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <h2 style={{ marginBottom: '1.5rem' }}>Criação de Envelope</h2>
                    <div>
                        <LabelInput
                            labelValue="Assunto"
                            value={values.subject}
                            onChange={(value) => handleEnvelopeInputChange("subject", value)}
                            onBlur={(value) => handleBlur("subject", value)}
                            error={touched.subject && values.subject === ""}
                            errorMessage={errorMessages.subject}
                        />
                    </div>
                    <div>
                        <LabelInput
                            labelValue="Data de Expiração (Opcional)"
                            value={values.expiration_date}
                            placeholder="DD/MM/AAAA"
                            onChange={(value) => handleEnvelopeInputChange("expiration_date", value)}
                            formatValue={(value) => formatDate(value)}
                            onBlur={(value) => handleBlur("expiration_date", value)}
                            error={(touched.expiration_date && ((!isValidDate(values.expiration_date) && values.expiration_date !== "") || (isDateOlderThanToday(values.expiration_date) && values.expiration_date !== "")))}
                            errorMessage={errorMessages.expiration_date}
                        />
                    </div>
                    <h2 style={{ marginBottom: '1.5rem' }}>Signatários</h2>
                    {signers.map((signer, index) => (
                        <div key={index}>
                            <div>
                                <LabelInput
                                    labelValue="Nome Completo"
                                    value={signer.name}
                                    onChange={(value) =>
                                        handleInputChange(index, "name", value)
                                    }
                                    onBlur={(value) => handleSignerBlur(index, "name", value)}
                                    error={touched.name && signer.name === ""}
                                    errorMessage={errorMessages.name}
                                />
                            </div>
                            <div>
                                <LabelInput
                                    labelValue="Data de Nascimento (Opcional)"
                                    value={signer.birthdate}
                                    placeholder="DD/MM/AAAA"
                                    onChange={(value) =>
                                        handleInputChange(index, "birthdate", value)
                                    }
                                    formatValue={(value) => formatDate(value)}
                                    onBlur={(value) => handleSignerBlur(index, "birthdate", value)}
                                    error={touched.birthdate && !isValidDate(signer.birthdate) && signer.birthdate !== ""}
                                    errorMessage={errorMessages.birthdate}
                                />
                            </div>
                            <div>
                                <LabelInput
                                    labelValue="CPF"
                                    value={signer.document_number}
                                    placeholder="000.000.000-00"
                                    onChange={(value) =>
                                        handleInputChange(index, "document_number", value)
                                    }
                                    onBlur={(value) => handleSignerBlur(index, "document_number", value)}
                                    formatValue={(value) => formatCPF(value)}
                                    error={(touched.document_number && signer.document_number === "") ||  (touched.document_number && !isValidCPF(signer.document_number))}
                                    errorMessage={errorMessages.document_number}
                                />
                            </div>
                            <div>
                                <LabelInput
                                    labelValue="E-mail"
                                    value={signer.email}
                                    onChange={(value) =>
                                        handleInputChange(index, "email", value)
                                    }
                                    onBlur={(value) => handleSignerBlur(index, "email", value)}
                                    error={touched.email && !isEmail(signer.email)}
                                    errorMessage={errorMessages.email}
                                />
                            </div>
                            <div>
                                <LabelInput
                                    labelValue="Telefone (Opcional)"
                                    value={signer.phone}
                                    placeholder="(00) 00000-0000"
                                    onChange={(value) =>
                                        handleInputChange(index, "phone", value)
                                    }
                                    formatValue={(value) => formatPhone(value)}
                                    onBlur={(value) => handleSignerBlur(index, "phone", value)}
                                    error={(touched.phone && !isPhone(signer.phone)) ||
                                      ((signer.document_submission_method === 'sms' || signer.authentication_submission_method === 'sms') && signer.phone === '') ||
                                      ((signer.document_submission_method === 'whatsapp' || signer.authentication_submission_method === 'whatsapp') &&  signer.phone === '') 
                                    }
                                    errorMessage={errorMessages.phone}
                                />
                            </div>
                            <div>
                                <h2 style={{ marginBottom: '1rem' }}>Método de Envio dos Documentos</h2>
                                <RadioGroup
                                    row
                                    name="document_submission_method"
                                    value={signer.document_submission_method}
                                    onChange={(event) => handleInputChange(index, "document_submission_method", event.target.value)}
                                >
                                    <FormControlLabel
                                        value="email"
                                        control={<Radio style={{ color: primaryColor, borderColor: primaryColor }} />}
                                        label="E-mail"
                                    />
                                    <FormControlLabel
                                        value="sms"
                                        control={<Radio style={{ color: primaryColor, borderColor: primaryColor }} />}
                                        label="SMS"
                                    />
                                    <FormControlLabel
                                        value="whatsapp"
                                        control={<Radio style={{ color: primaryColor, borderColor: primaryColor }}/>}
                                        label="WhatsApp"
                                    />
                                </RadioGroup>
                                {documentSubmissionErrors[index] && signer.document_submission_method === '' && <p style={{ color: '#B22300' }}>{errorMessages.document_submission_method}</p>}
                            </div>
                            <div>
                                <h2 style={{ marginBottom: '1rem' }}>Método de Envio da Autenticação</h2>
                                <RadioGroup
                                    row
                                    name="authentication_submission_method"
                                    value={signer.authentication_submission_method}
                                    onChange={(event) => handleInputChange(index, "authentication_submission_method", event.target.value)}
                                >
                                    <FormControlLabel
                                        value="email"
                                        control={<Radio style={{ color: primaryColor, borderColor: primaryColor }} />}
                                        label="E-mail"
                                    />
                                    <FormControlLabel
                                        value="sms"
                                        control={<Radio style={{ color: primaryColor, borderColor: primaryColor }}/>}
                                        label="SMS"
                                    />
                                    <FormControlLabel
                                        value="whatsapp"
                                        control={<Radio style={{ color: primaryColor, borderColor: primaryColor }}/>}
                                        label="WhatsApp"
                                    />
                                    {authenticationSubmissionErrors[index] && signer.authentication_submission_method === '' && <p style={{ color: '#B22300' }}>{errorMessages.authentication_submission_method}</p>}
                                </RadioGroup>
                            </div>
                            <Button
                                variant="outlined"
                                startIcon={<RemoveCircleOutlineIcon />}
                                style={{ width: '100%', margin: '.5rem 0', color: primaryColor, borderColor: primaryColor }}
                                onClick={() => handleRemoveSigner(index)}
                            >
                                Remover Signatário
                            </Button>
                        </div>
                    ))}
                    <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<AddCircleOutlineIcon />}
                        style={{ width: '100%', margin: '.5rem 0', color: primaryColor, borderColor: primaryColor }}
                        onClick={handleAddSigner}
                    >
                        Adicionar Signatário
                    </Button>
                    <div>
                        <h2 style={{ marginBottom: '1rem' }}>Documentos Anexados</h2>
                        <input
                            type="file"
                            id="attach-document"
                            multiple
                            style={{ display: "none" }}
                            onChange={handleAttachDocument}
                        />
                        <label htmlFor="attach-document">
                            <Button
                                variant="outlined"
                                color="primary"
                                startIcon={<AttachFileIcon />}
                                style={{ width: '100%', margin: '.5rem 0', color: primaryColor, borderColor: primaryColor }}
                                component="span"
                                onClick={() => document.getElementById('attach-document')}
                            >
                                Anexar Documento
                            </Button>
                        </label>
                        <ul>
                            {attachedDocuments.map((document) => (
                                <li key={document.id}>
                                    {document.name}
                                    <IconButton
                                        aria-label="Remover"
                                        onClick={() => handleRemoveDocument(document.id)}
                                    >
                                        <RemoveCircleOutlineIcon />
                                    </IconButton>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div style={{ alignItems: 'center', textAlign: 'center' }}>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={handleSubmit} 
                            style={{ width: '100%', margin: '2rem 0', backgroundColor: primaryColor }}
                        >
                            Enviar
                        </Button>
                    </div>
                </div>
            </Dialog>
            {openDemoRequestModal && (
                <>
                <Modal open={openDemoRequestModal} onClose={closeDemoRequestModal}>
                    <Box sx={minorboxStyles}>
                    <S.MinorModalBoxContainer>
                        <ErrorOutlineOutlinedIcon
                        style={{ color: "red", fontSize: 40 }}
                        ></ErrorOutlineOutlinedIcon>
                        <S.InternalDialogContainerDescription>
                        A sua conta atingiu o limite máximo para criação de envelope teste.
                        Faça a ativação do seu plano e continue aproveitando os beneficios do Qi Sign.
                        </S.InternalDialogContainerDescription>
                        <S.MinorModalButtonContainer
                        onClick={() => closeDemoRequestModal()}
                        >
                        <S.ModalButtonDescription>
                            Voltar
                        </S.ModalButtonDescription>
                        </S.MinorModalButtonContainer>
                    </S.MinorModalBoxContainer>
                    </Box>
                </Modal>
                </>
            )}
        </>
    )
};

export default EnvelopeCreationDialog
